import Image from 'next/image';
import Link from 'next/link';
import { footerLinks } from 'src/data/siteMapItems';
import { socialLinks } from 'src/data/social';
import HoveredLink from '../HoveredLink';

export function Footer() {
    return (
        <footer className="bg-white/30 border-t border-gray-200 md:-mx-8">
            <div className="max-w-screen-xl mx-auto px-4 py-12">
                <div className="grid items-start grid-cols-1 lg:grid-cols-3 md:gap-8">
                    {/* Company Info Section */}
                    <div className="col-span-1">
                        <div className="flex items-center justify-start mb-4">
                            <h2 className="text-2xl font-bold">ClaireChains</h2>
                        </div>
                        <div>
                            <p className="mb-4 mr-0 flex justify-center text-left text-base font-normal text-[#556578] md:max-w-[400px] lg:text-left">
                                Creating AI platforms and services that let anyone build and deploy AI services at scale, anytime and anywhere.
                            </p>
                            <div className="hidden text-base text-[#8A9FB8] md:block">
                                <p className="mb-8">© 2022 ClaireChains. All rights reserved.</p>
                            </div>
                            <div className="z-[9999] flex cursor-pointer justify-center space-x-6 lg:justify-start">
                                {socialLinks.map((social) => (
                                    <Link
                                        key={social.id}
                                        id={social.id}
                                        href={social.href}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="group"
                                    >
                                        <Image
                                            alt={social.title}
                                            width={24}
                                            height={24}
                                            src={social.icon}
                                            className="w-6 h-6 cursor-pointer opacity-60 group-hover:opacity-100 transition-opacity duration-300"
                                        />
                                    </Link>
                                ))}
                            </div>
                        </div>
                        <hr className="my-6 border-gray-600 opacity-20 lg:hidden" />
                    </div>

                    {/* Links Section */}
                    <div className="col-span-2 sm:m-0 lg:ml-auto">
                        <div className="grid gap-6 sm:grid-cols-2 md:gap-x-[88px] md:gap-y-6">
                            {/* Column 1 */}
                            <div className="inline-flex flex-col gap-[12px] md:order-1 items-start">
                                {footerLinks.column1.map((link) => (
                                    <HoveredLink
                                        key={link.id}
                                        href={link.href}
                                    >
                                        {link.label}
                                    </HoveredLink>
                                ))}
                            </div>

                            {/* Column 3 */}
                            <div className="z-1 inline-flex flex-col items-start gap-[12px] xs:order-2 md:order-3">
                                {footerLinks.column3.map((link) => (
                                    <HoveredLink
                                        key={link.id}
                                        href={link.href}
                                    >
                                        {link.label}
                                    </HoveredLink>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}